/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SearchInputs */

const en_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fr_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const ja_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const ar_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const id_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const it_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const ru_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найти`)
};

const pt_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ko_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {SearchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search = /** @type {((inputs?: SearchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SearchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search(inputs)
	if (locale === "es") return es_search(inputs)
	if (locale === "fr") return fr_search(inputs)
	if (locale === "de") return de_search(inputs)
	if (locale === "ja") return ja_search(inputs)
	if (locale === "zh") return zh_search(inputs)
	if (locale === "ar") return ar_search(inputs)
	if (locale === "id") return id_search(inputs)
	if (locale === "it") return it_search(inputs)
	if (locale === "ru") return ru_search(inputs)
	if (locale === "pt") return pt_search(inputs)
	return ko_search(inputs)
});